/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NftGenerateModel from './NftGenerateModel';

/**
 * The NftGeneratorControllerDtoNftGenerateRequest model module.
 * @module model/NftGeneratorControllerDtoNftGenerateRequest
 * @version 1.0
 */
class NftGeneratorControllerDtoNftGenerateRequest {
    /**
     * Constructs a new <code>NftGeneratorControllerDtoNftGenerateRequest</code>.
     * @alias module:model/NftGeneratorControllerDtoNftGenerateRequest
     */
    constructor() { 
        
        NftGeneratorControllerDtoNftGenerateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGeneratorControllerDtoNftGenerateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGeneratorControllerDtoNftGenerateRequest} obj Optional instance to populate.
     * @return {module:model/NftGeneratorControllerDtoNftGenerateRequest} The populated <code>NftGeneratorControllerDtoNftGenerateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGeneratorControllerDtoNftGenerateRequest();

            if (data.hasOwnProperty('nftGenerateModelList')) {
                obj['nftGenerateModelList'] = ApiClient.convertToType(data['nftGenerateModelList'], [NftGenerateModel]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGeneratorControllerDtoNftGenerateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGeneratorControllerDtoNftGenerateRequest</code>.
     */
    static validateJSON(data) {
        if (data['nftGenerateModelList']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['nftGenerateModelList'])) {
                throw new Error("Expected the field `nftGenerateModelList` to be an array in the JSON data but got " + data['nftGenerateModelList']);
            }
            // validate the optional field `nftGenerateModelList` (array)
            for (const item of data['nftGenerateModelList']) {
                NftGenerateModel.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<module:model/NftGenerateModel>} nftGenerateModelList
 */
NftGeneratorControllerDtoNftGenerateRequest.prototype['nftGenerateModelList'] = undefined;






export default NftGeneratorControllerDtoNftGenerateRequest;

